// App download store links and rating figures for the App Download banner.

interface AppStoreLinks {
    android: string
    ios: string
}

export const FLYIN_APP_LINKS: AppStoreLinks = {
    android: 'https://play.google.com/store/apps/details?id=com.flyin.bookings',
    ios: 'https://apps.apple.com/us/app/flyin-flights-hotel-deals/id1106268318'
}

export const CLEARTRIP_APP_LINKS: AppStoreLinks = {
    android: 'https://play.google.com/store/apps/details?id=me.cleartrip.android',
    ios: 'https://apps.apple.com/in/app/cleartrip-me-flight-hotel/id6479165589'
}

export const APP_RATINGS = {
    GOOGLE_PLAY: '4.3',
    APP_STORE: '4.2',
    DOWNLOADS: '1M +'
}

export type { AppStoreLinks }
